import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { COOKIES } from '~/constants/srp';
import { useIsTradeInApplied } from '~/context/common/TradeContext';
import BrowserCookies from '~/utilities/BrowserCookies';

export default function useToggleAppliedTradeCookie(): void {
  const isTradeInApplied = useIsTradeInApplied();

  useSubsequentEffect(() => {
    if (isTradeInApplied) {
      BrowserCookies.remove(COOKIES.hasAppliedTrade);
    } else {
      BrowserCookies.set(COOKIES.hasAppliedTrade, String(false));
    }
  }, [isTradeInApplied]);
}
